import {Component, DoCheck, Inject, Input, OnInit, QueryList, ViewChildren} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDatepicker} from '@angular/material/datepicker';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {constants} from 'src/app/shared/common/contants';
import {ErrorMessages} from 'src/app/shared/common/errormessages';
import {validationmethod} from 'src/app/shared/common/validationmethod';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import {LocalStorageSettingsService} from 'src/app/shared/services/local-storage-settings.service';
import {CommonService} from 'src/app/shared/services/common.service';
import * as moment from 'moment';
import {Moment} from 'moment';
import {NgxUiLoaderService} from 'ngx-ui-loader';

import {Actionbutton} from 'src/app/shared/common/Actionbutton';
import {IncrDataLoadScheduleService} from '../../../shared/services/incr-data-load-schedule.service';
import {BreakpointObserver} from '@angular/cdk/layout';
import {MatSelect} from '@angular/material/select';
import {first} from 'rxjs';


export interface checkinListDialogData {
  scheduleData: any;

  edata: any;
  page: any;
  columns: any;
  scheduleFor:any;
  purgeId:any;
}

@Component({
    selector: 'app-incremental-data-load-schedule-popup',
    templateUrl: './incremental-data-load-schedule-popup.component.html',
    styleUrls: ['./incremental-data-load-schedule-popup.component.scss'],
    standalone: false
})
export class IncrementalDataLoadSchedulePopupComponent  implements OnInit {

  FormValid: FormGroup;
  _max: Moment;
  _min: Moment;
  _inputCtrl: FormControl = new FormControl();
  gridAPI;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  gridColumnAPI;
  gridColumnAPIDispatch;
  columnDefs;
  rowData;
  rowClassRules;
  defaultColDef;
  rowSelection;
  paginationPageSize;
  paginationNumberFormatter;
  pageSize;
  components: any;
  btnName: any;
  validation_messages: any;
  backgroundColorButton = '';
  batchPlantCompanyData: any;
  endDateTemp: any = moment.utc();
  startDatetemp: any =moment.utc();
  timestamptemp: any = moment.utc();
  currentTimeStamp: any =moment.utc();
  scheduleid: any;
  startYear: any;
  endYear: any;
  timeScheduleDescription: string;
  scheduledOn: any = [];
  materialData: any;
  options: any = [];
  dayofWeek: any = [{name: 'Monday', id: "MON"}, {name: 'Tuesday', id: "TUE"}, {name: 'Wednesday', id: "WED"}, {
    name: 'Thursday',
    id: "THU"
  }, {name: 'Friday', id: "FRI"}, {name: 'Saturday', id: "SAT"}, {name: 'Sunday', id: "SUN"},];
  dayOfMonth: any = [];
  yearsDropDown: any = [];
  date: any;
  gridReadParam
  header
  header2
  customreportmstrid
  headerName
  scheduleFor
  gridOptions
  selectedOption: string;
  startingYear: number;
  intervalYears: number;
  selectedYears: number[] = [];
  availableYears: number[] = [];
  start: number;
  end: number;
  alternativeRecurrence
  alternativeRecurrences
  days = Array.from(Array(31).keys()).map(day => day + 1);
  weeks = Array.from(Array(7).keys()).map(week => week + 1);
  hours = Array.from(Array(24).keys()).map(hour => hour + 1);
  month = Array.from(Array(12).keys()).map(hour => hour + 1);
  year = Array.from(Array(84).keys()).map(hour => hour + 1);
  minutes = Array.from({ length: (55 - 5) / 5 + 1 }, (_, index) => 5 + index * 5);
  dateType: any = ""
  months;
  years
  dateRange
  startDate
  endDate
  currentMonth = moment().month() + 1
  monthType
  showOnlyButtons = false;
  monthsDropDown = [
    {name: "January", id: "JAN"}, {name: "February", id: "FEB"}, {name: "March", id: "MAR"}, {name: "April", id: "APR"}, {
      name: "May",
      id: "MAY"
    }, {name: "June", id: "JUN"}, {name: "July", id: "JUL"}, {name: "August", id: "AUG"}, {name: "September", id: "SEP"}, {
      name: "October",
      id: "OCT"
    }, {name: "November", id: "NOV"}, {name: "December", id: "DEC"}
  ];
  monthTypeDropDown = [{name: "January", id: 1},
    {name: "February", id: 2},
    {name: "March", id: 3},
    {name: "April", id: 4},
    {name: "May", id: 5},
    {name: "June", id: 6},
    {name: "July", id: 7},
    {name: "August", id: 8},
    {name: "September", id: 9},
    {name: "October", id: 10},
    {name: "November", id: 11},
    {name: "December", id: 12}
  ]
  formControlsToDisable = ['month', 'year', 'startDate', 'endDate'];
  formcontrolForReset = ['scheduledOn', 'month', 'year', 'startDate', 'endDate', 'monthType']
  migrationid;
  migratioType;

  purgeid;

  @ViewChildren(MatSelect) selects: QueryList<MatSelect>;

  constructor(public dialogref: MatDialogRef<IncrementalDataLoadSchedulePopupComponent>, private localStorageSettings: LocalStorageSettingsService,
              @Inject(MAT_DIALOG_DATA) public data: checkinListDialogData, private snackbar: MatSnackBar, private errorMsg: ErrorMessages,
              private constants: constants,
              private validation: validationmethod,
              private fb: FormBuilder,
              private secheduleService: IncrDataLoadScheduleService,
    private commanService: CommonService,
              private service: ReportingServiceService,
              private spinner: NgxUiLoaderService,
              private responsive: BreakpointObserver) {
    this.validation_messages = this.errorMsg.concreteUpdateReportMessages;
    this.components = {
      buttonRenderer: Actionbutton,
    };
  }


  ngAfterViewInit() {
    this.selects.forEach(select => {
      this.timescheduleDescription();
    });
  }
  ngOnInit() {

    this.responsive.observe("(max)")
    const currentYear = new Date().getFullYear();
    this.formvalidations();



    this.alternativeRecurrence = 1; 

    for (let year = currentYear - 10; year <= currentYear + 10; year++) {
      this.availableYears.push(year);
    }

    this.yearsDropDown.push({name: "Every Year", id: "*"});

    const currentYears = new Date().getFullYear();
    for (let i = 0; i < 10; i++) {
      const year = currentYears + i;
      this.yearsDropDown.push({name: year.toString(), id: year});
    }
    console.log(this.data);
    this.scheduleFor = this.data.scheduleFor
    if (this.data.edata) {
      this.customreportmstrid = this.data.edata.customreportmstrid

      console.log(this.customreportmstrid);
    } else {
      this.customreportmstrid = 0
    }

    /* @added by Ravi G
         @date 06-03 2023
         @desc set header on schedulerFor
    */
    if (this.data.scheduleFor == 'Report Hub') {
      this.header = "Schedule Report - " + this.data.edata.reporttemplatename

      this.customreportmstrid = this.data.edata.reporttemplateid

    } else if (this.data.scheduleFor == 'Incremental Data') {


      this.header = "Schedule Incremental Data Load"
    } else if (this.data.scheduleFor == 'Report Template') {

      this.header = "Schedule Report Template"

      this.customreportmstrid = this.data.edata.customreportmstrid

    }
    else if (this.data.scheduleFor == 'IncrementalDataLoad') {

      this.header = "Schedule Data Load"
      this.migrationid=this.data.edata.migrationid;
      
       this.customreportmstrid = this.data.edata.customreportmstrid

    }
    else if(this.data.scheduleFor == 'Purging Data'){
       /*
       Author- Venkata Shyam
       20-12-2024
       checking the whether it is scheduled for purgeing
        */

      this.header = "Schedule Purge Records"
      this.purgeid= this.data.purgeId;
    } else if (this.data.scheduleFor == 'Dataset Refresh') {
      /*
      Author- Aman Singh
      20-12-2024
      checking the whether it is scheduled for Dataset Refresh
       */
      console.log(this.data.edata)
      console.log(this.data.edata.rowData.reportcreationid)


      this.header = "Schedule Dataset Refresh"
      this.header2 = "Instant Refresh"
      //this.purgeid = this.data.purgeId;
      this.migrationid = this.data.edata.rowData.reportcreationid;
      

    } else if(this.data.scheduleFor == 'pss_doc_Schedule'){
  /**
   * @author Rahul Vk
   * @Date 13-11-205
   * @Desc checking the whether it is scheduled for Product Strategy Document Schedule
   */
      this.header = "Product Strategy Document Schedule"

    }
    else if(this.data.scheduleFor == 'jsip_meeting_schedule'){
  /**
   * @author Rahul Vk
   * @Date 05-02-2056
   * @Desc checking the whether it is scheduled for Product Strategy Document Schedule
   */
      this.header = "Meeting Schedule"

    }
    this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
    this.date = 'daily';
    if (this.date === 'daily') {
      this.alternativeRecurrences = this.days
    }

    this.timestamptemp = moment.utc();
    this.scheduleData();
    console.log(this.date);

    for (let i = 1; i <= 30; i++) {

      this.dayOfMonth.push({'name': moment.utc(i, 'Do').format('Do'), 'id': i});
    }

    this.btnName = 'Save';
  
  
    this.dayOfMonth.push({'name': "31st", 'id': 31});

    this.dayOfMonth.push({'name': "Last day of month", 'id': "Last day of month"});
    this.dayOfMonth.push({'name': "Last working day of month", 'id': "Last working day of month"});

    this.timescheduleDescription();
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },

      sortable: true,

      resizable: true,

      filter: true

    };
    this.columnDefs = []
    this.rowSelection = 'single'

      this.columnDefs = [
        {
          headerName: 'Action',
          filter: false,
          cellRenderer: 'buttonRenderer',
          // cellRenderer: 'buttonRenderer',
          cellRendererParams: {
            edit: this.editIcon.bind(this),
            delete: this.deleteIcon.bind(this)
          },
          pinned: 'left',
          lockPinned: true,
          width: 180,
        },

        {
          headerName: 'Schedule Id',
          headerTooltip: 'Schedule Id',
          tooltipValueGetter: (params) =>
            'Schedule Id : ' + params.value,
          field: 'scheduleid',
          filter: 'agTextColumnFilter',
          width: 100,
        },
        {
          headerName: 'Schedule Description',
          headerTooltip: 'Schedule Description',
          tooltipValueGetter: (params) =>
            'Schedule Description: ' + params.value,
          field: 'scheduleDesc',
          filter: 'agTextColumnFilter',
          width: 500,
        },
        {
          headerName: 'Start Year',
          headerTooltip: 'Start Year',
          tooltipValueGetter: (params) =>
            'Start Year : ' + params.value,
          field: 'scheduleDate',
          filter: 'agTextColumnFilter',
          width: 180,
        },
        {
          headerName: 'Time',
          headerTooltip: 'Time',
          tooltipValueGetter: (params) =>
            'Time : ' + params.value,
          field: 'scheduletime',
          filter: 'agTextColumnFilter',
          width: 180,
        },
        {
          headerName: 'End Year',
          headerTooltip: 'End Year',
          tooltipValueGetter: (params) =>
            'End Year : ' + params.value,
          field: 'enddate',
          filter: 'agTextColumnFilter',
          width: 180,
        },
        {
          headerName: 'Scheduled On',
          headerTooltip: 'Scheduled On',
          tooltipValueGetter: (params) =>
            'Scheduled On : ' + params.value,
          field: 'scheduledOn',
          filter: 'agTextColumnFilter',
          width: 180,
        },

        {
          headerName: 'Repeat Type',
          headerTooltip: 'Repeat Type',
          tooltipValueGetter: (params) =>
            'Repeat Type : ' + params.value,
          field: 'repeattype',
          filter: 'agTextColumnFilter',
          width: 180,
        },
        {
          headerName: 'Alternative Recurrence',
          headerTooltip: 'Alternative Recurrence',
          tooltipValueGetter: (params) => 'Alternative Recurrence : ' + params.value,
          field: 'alternativeRecurrence',
          filter: 'agTextColumnFilter',
          width: 180,
        },
        {
          headerName: 'Months',
          headerTooltip: 'Months',
          tooltipValueGetter: (params) => 'Months : ' + params.value,
          field: 'months',
          filter: 'agTextColumnFilter',
          width: 180,
        },
        {
          headerName: 'Years',
          headerTooltip: 'Years',
          tooltipValueGetter: (params) => 'Years : ' + params.value,
          field: 'years',
          filter: 'agTextColumnFilter',
          width: 180,
        },
        {
          headerName: 'Created By',
          headerTooltip: 'Created By',
          tooltipValueGetter: (params) =>
            'Created By : ' + params.value,
          field: 'createdBy',
          filter: 'agTextColumnFilter',
          width: 180,
        },

        {
          headerName: 'Created Date',
          headerTooltip: 'Created Date',
          tooltipValueGetter: (params) =>
            'Created Date : ' + params.value,
          field: 'createdDate',
          filter: 'agTextColumnFilter',
          width: 180,
        },

        {
          headerName: 'Last Modified By',
          headerTooltip: 'Last Modified By',
          tooltipValueGetter: (params) =>
            'Last Modified By : ' + params.value,
          field: 'lastModifiedBy',
          filter: 'agTextColumnFilter',
          width: 180,
        },
        {
          headerName: 'Last Modified Date',
          headerTooltip: 'Last Modified Date',
          tooltipValueGetter: (params) =>
            'Last Modified Date: ' + params.value,
          field: 'lastModifiedDate',
          filter: 'agTextColumnFilter',
          width: 180,
        },


      ];


    this.updateFormControlsAvailability()


  }

  formvalidations() {
    this.FormValid = new FormGroup({
      date: new FormControl(''),
      timeScheduleDescription: new FormControl(''),
      startYear: new FormControl('', [Validators.required]),
      endYear: new FormControl('', [Validators.required]),
      scheduletime: new FormControl('', [Validators.required,]),
      alternativeRecurrence: new FormControl('', [Validators.required,]),

      scheduledOn: new FormControl('', [Validators.required,]),
      month: new FormControl('', [Validators.required,]),
      year: new FormControl('', [Validators.required,]),
      startDate: new FormControl('', []),
      endDate: new FormControl('', ),
      monthType:new FormControl('', [Validators.required,]),
    });

  }


  /**
   * @author Ravi G
   * @Date 23-01-2023
   * @Desc user select the daily, weekly, monthly schedular will call
   * if user select weekly scheduledOn means the which day 1sth ,3fst
   */
  ChangeSelect(event) {
    console.log(this.yearsDropDown);    
// || event.value == 'minutes'|| event.value == 'hourly'
    if (event.value == 'daily' ) {
      this.alternativeRecurrences = this.days;
    } else if (event.value == 'weekly') {
      this.dateType = "Day of Week"
      this.alternativeRecurrences = this.weeks
      this.options = this.dayofWeek;
      console.log(this.options);
    } else if (event.value == 'monthly') {
      this.dateType = "Select Day of Month"
      this.options = this.dayOfMonth;
      this.months = this.currentMonth
      this.alternativeRecurrences = this.month
      
    } else if (event.value == 'yearly') {
      this.dateType = "Select Day of Month"
      this.options = this.dayOfMonth;
      this.alternativeRecurrences = this.year;
    } else if (event.value == 'hourly') {
      this.alternativeRecurrences = this.hours;     
    }else if(event.value == 'minutes'){
      this.alternativeRecurrences = this.minutes;
    }

    if (event.value == 'yearly') {
      this.FormValid.get('alternativeRecurrence').enable();
      this.FormValid.get('scheduledOn').enable();
      this.FormValid.get('year').enable();
      this.FormValid.get('month').enable();
      this.options = this.dayOfMonth;
    }
    this.updateFormControlsAvailability();
    this.timescheduleDescription();

  }


  onGridReady(params) {
    this.gridReadParam = params
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    this.scheduleData();

  }

  scheduleData() {
    console.log(this.scheduleFor, this.customreportmstrid)
   
    this.spinner.start();
    let dataTemporary: any = [];
    if (this.scheduleFor == 'Report Template') {
      this.secheduleService.extractionScheduleListByScheduleForAndReportTemplate(this.scheduleFor, this.customreportmstrid).subscribe(res => {
console.log(res)

        if (res.error == true) {
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, 'OK', {duration: 5000,});

        } else {

          this.spinner.stop();
          dataTemporary = res;

          for (let i = 0; i < dataTemporary.length; i++) {
            dataTemporary[i].scheduletime = moment(dataTemporary[i].scheduletime, 'hh:mm').format('hh:mm A');
          }
          this.gridAPI.setGridOption('rowData', dataTemporary);

        }

      });

    }
    else if(this.scheduleFor=='pss_doc_Schedule') {
  /**
  * Modified :Rahul Vk
  * @Date - 13/11/2025
  * calling the retrving scheduler code for individual Pss Id
  */ 
     
     this.secheduleService.extractionScheduleListByScheduleForAndReportTemplate(this.scheduleFor,this.customreportmstrid).subscribe(res => {


       if (res.error == true) {
         this.spinner.stop();
         this.snackbar.open(res.statusMessage, 'OK', {duration: 5000,});

       } else {

         this.spinner.stop();
         dataTemporary = res;

         for (let i = 0; i < dataTemporary.length; i++) {
           dataTemporary[i].scheduletime = moment(dataTemporary[i].scheduletime, 'hh:mm').format('hh:mm A');

         }
         this.gridAPI.setGridOption('rowData', dataTemporary);

       }

     });
   }else if(this.scheduleFor=='Purging Data') {
      /**
  * Modified :Shyam
  * @Date - 24/02/2025
  * calling the retrving scheduler code for individual purgeId
  */
     this.secheduleService.extractionScheduleListByScheduleForAndReportTemplate(this.scheduleFor,this.purgeid).subscribe(res => {


       if (res.error == true) {
         this.spinner.stop();
         this.snackbar.open(res.statusMessage, 'OK', {duration: 5000,});

       } else {

         this.spinner.stop();
         dataTemporary = res;

         for (let i = 0; i < dataTemporary.length; i++) {
           dataTemporary[i].scheduletime = moment(dataTemporary[i].scheduletime, 'hh:mm').format('hh:mm A');

         }
         this.gridAPI.setGridOption('rowData', dataTemporary);

       }

     });
   }
   else if(this.scheduleFor=='jsip_meeting_schedule') {
  /**
  * Modified :Rahul Vk
  * @Date - 05/02/2026
  * calling the retrving scheduler code for individual Meeting Id
  */ 
     this.secheduleService.extractionScheduleListByScheduleForAndReportTemplate(this.scheduleFor,this.customreportmstrid).subscribe(res => {
      if (res.error == true) {
           this.spinner.stop();
         this.snackbar.open(res.statusMessage, 'OK', {duration: 5000,});
       } 
       else {
         this.spinner.stop();
         dataTemporary = res;
         for (let i = 0; i < dataTemporary.length; i++) {
           dataTemporary[i].scheduletime = moment(dataTemporary[i].scheduletime, 'hh:mm').format('hh:mm A');

         }
         this.gridAPI.setGridOption('rowData', dataTemporary);

       }

     });
   }
     else {
       /**
   * Modified : Abhishek Tomar
   * @Date - 01/01/2025
   * calling the retrving scheduler code for individual migrationId
   */
      this.secheduleService.extractionScheduleListByScheduleForAndReportTemplate(this.scheduleFor,this.migrationid).subscribe(res => {


        if (res.error == true) {
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, 'OK', {duration: 5000,});

        } else {

          this.spinner.stop();
          dataTemporary = res;

          for (let i = 0; i < dataTemporary.length; i++) {
            dataTemporary[i].scheduletime = moment(dataTemporary[i].scheduletime, 'hh:mm').format('hh:mm A');

          }
          this.gridAPI.setGridOption('rowData', dataTemporary);

        }

      });
    }

  }

  onPaginationChangedReturn() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;
      this.nextPagePlusOne =
        this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;
      this.totalPages = this.gridAPI.paginationGetTotalPages();
    }
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    console.log('Return page size');
    let value = this.pageSize;
    this.gridAPI.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log('next');
    this.gridAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log('previous');
    this.gridAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }

  //excel export function
  onBtExport() {
    this.gridAPI.exportDataAsCsv();
  }

  onSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  close() {
    this.dialogref.close();
    this.showOnlyButtons = false;
  }

  clear() {
    this.clearData();
  }

  clearData() {

      Object.keys(this.FormValid.controls)
        .filter(key => this.formcontrolForReset.includes(key))
        .forEach(key => this.FormValid.get(key).reset());

    this.scheduleid = null;
    this.alternativeRecurrence = 1
    let startdate = moment.utc()
    this.endDateTemp = startdate;
    this.startDatetemp = startdate;
    this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
    this.date = 'daily';
    this.scheduleid = null;
    this.scheduledOn = null;
    this.timestamptemp = moment.utc();
    this.currentTimeStamp = moment.utc()
    console.log(this.date);
    this.btnName = 'Save';
    this.date = 'daily'
    this.updateFormControlsAvailability();
   
  }

  async updateData() {
    
    console.log('Time: ' + moment(this.timestamptemp).format('HH:mm') + ' ' + 'starttime: ' + this.startDatetemp + ' ' + 'endtime: ' + this.endDateTemp + ' ' + 'repeat: ' + this.scheduledOn + ' ' + 'datetype: ' + this.date);
    if (!this.FormValid.valid) {
      const requiredField : any = Object.keys(this.FormValid.controls).find(
        (controlName) => this.FormValid.controls[controlName].hasError('required')
      );
      console.log(requiredField);
      const requiredFieldName = this.FormValid.get(requiredField)
      console.log(requiredFieldName);
      console.log(`The ${requiredFieldName} field is required`);
      this.snackbar.open(`The ${requiredFieldName} field is required`, 'OK', {duration: 5000,});

      this.validation.validateAllFormFields(this.FormValid);
      this.validation.getvalidationmessage();
      return;
    } else {
      console.log(this.date)
      console.log(this.data.edata)
      console.log(this.alternativeRecurrence)
      this.migratioType = this.data?.edata?.migrationType ?? null;

   if (
  this.data?.edata &&
  this.date === "minutes" &&
  this.migratioType === "Data Virtualization (Direct Data API)" &&
  this.alternativeRecurrence < 15
) {
  this.snackbar.open("Please set the interval of minimum 15 minutes", 'OK', {
    duration: 5000,
  });
  return;
}

      let startDate = moment(this.startDatetemp).format('YYYY-MM-DD');
      let endDate = moment(this.endDateTemp).format('YYYY-MM-DD');
      let scheduletime = moment(this.timestamptemp).format('HH:mm');
      let userName = localStorage.getItem('AuthUsername');
      let userid = localStorage.getItem('userid');
      if (this.date != 'yearly') {
        this.FormValid.get('month').reset();
        this.FormValid.get('year').reset();
      }
      let months
      if(this.date =='yearly'){
        months =  this.months
      }else{
        months = this.monthType
      }
      let obj = {
        scheduleid: this.scheduleid,
        scheduletime: scheduletime,
        status: 'Yes',
        userid: userid,
        createdbyuser: userName,
        scheduleDate: startDate,
        enddate: endDate,
        scheduledOn:  this.date =='daily' || this.date === 'minutes'? null : String(this.scheduledOn),
        repeattype: this.date,
        customreportmstrid: this.customreportmstrid,
        scheduleFor: this.scheduleFor,
        alternativeRecurrence: this.alternativeRecurrence,
        months:String(months),
        years:this.date !='yearly'? null : String(this.years),
        scheduleDesc:this.timeScheduleDescription,
        migrationid:this.migrationid,
        purgeid:this.purgeid

      };
      this.spinner.start();
      console.log(obj)
     // debugger
      this.secheduleService.insertExtractionSchedule(obj).subscribe(response => {
        console.log(response);
        if (response.error == true) {
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, 'OK', {duration: 5000,});

        } else {
          console.log(this.btnName);
          if (this.btnName == 'Update') {
            this.snackbar.open(this.constants.successfullyUpdated, 'OK', {
              duration: 5000,
            });

          } else if (this.btnName == 'Save') {
            this.snackbar.open(this.constants.successfullyInserted, 'OK', {
              duration: 5000,
            });
          }
          this.scheduleData();
          this.spinner.stop();
          this.clearData();

        }
      });
    }
  }

  timescheduleDescription() {
    console.log('inside timeschedule');
    const startyear = moment.utc(this.startDatetemp).format('YYYY');
    const endyear = moment.utc(this.endDateTemp).format('YYYY');
    console.log('end year:', endyear);
    const scheduletime = moment(this.timestamptemp).format('hh:mm A');

    console.log('startDate:', startyear);
    console.log('repeat frequency:', this.scheduledOn);

    console.log();
    console.log(this.dayOfMonth);
    console.log(this.months)

    if (this.date === 'daily') {
      console.log('inside daily');

      this.timeScheduleDescription = `At ${scheduletime},every ${this.alternativeRecurrence} days starting on the 1st, every month`;
    } else if (this.date === 'weekly') {

      this.timeScheduleDescription = `At ${scheduletime}, on every ${this.scheduledOn}, every month`;
    } else if (this.date === 'monthly') {
      console.log('monthly');
      if(this.monthType) {
        const monthType = this.monthTypeDropDown.find(month => month.id === this.monthType)
        console.log(monthType);
        if (this.scheduledOn === 'Last working day of month') {
          // At 15:50:00pm, on the 1st day, every 3 months starting in April
          this.timeScheduleDescription = `At ${scheduletime}, Last working day of every ${this.alternativeRecurrence} month, starting in ${this.monthTypeDropDown.find(month => month.id === this.monthType).name}`;
        } else if (this.scheduledOn === 'Last day of month') {
          const monthType = this.monthTypeDropDown.find(month => month.id === this.monthType)
          console.log(monthType);
          this.timeScheduleDescription = `At ${scheduletime}, Last day of every ${this.alternativeRecurrence} month, starting in ${this.monthTypeDropDown.find(month => month.id === this.monthType).name}`
        } else {
          this.timeScheduleDescription = `At ${scheduletime}, on the ${this.scheduledOn} day, every ${this.alternativeRecurrence} month, starting in ${this.monthTypeDropDown.find(month => month.id === this.monthType).name}`
        }

      }
    }
    else if(this.date === 'yearly'){      
      // 0 16 16 3 JAN ? */3
   //   At 16:16:00pm, on the 1st day, in January,
      if (this.years != undefined && this.years.includes('*'))
      {
        this.years = ['*']

        this.timeScheduleDescription = `At ${scheduletime}, on the ${this.scheduledOn} day, in ${this.months} , every ${this.alternativeRecurrence} years starting in Every Year`
      }else{


        let yearString = this.years;
        console.log(this.years);
        let [lastYear, ...otherYears] = yearString.reverse();

        console.log(otherYears);
        console.log(lastYear);
        if (yearString.length == 1) {

          this.timeScheduleDescription = `At ${scheduletime}, on the ${this.scheduledOn}, in ${this.months},every ${this.alternativeRecurrence} years starting in ${this.years}`

        } else{
          this.timeScheduleDescription = `At ${scheduletime}, on the ${this.scheduledOn}, in ${this.months}, ${otherYears.reverse()}, and every ${this.alternativeRecurrence} years starting in ${lastYear}`

        }




      }


    }else if(this.date === 'minutes'){      
       this.timeScheduleDescription = `At ${scheduletime},after every ${this.alternativeRecurrence} minutes.`;
    }else if(this.date ==='hourly'){
      this.timeScheduleDescription = `At ${scheduletime},after every ${this.alternativeRecurrence} hour.`;
    }
  //   console.log('timeScheduleDescriptions:', timeScheduleDescriptions);
  //   this.FormValid.get('timeScheduleDescription').setValue(timeScheduleDescriptions);
  }

  editIcon(e) {

    console.log(e.rowData);
    console.log('editIcon');
    console.log(e.rowData.endDate);
    this.scheduleid = e.rowData.scheduleid;
    this.btnName = 'Update';
    console.log('start Date:' + moment(e.rowData.scheduleDate, 'YYYY-MM-DD'));
    this.timestamptemp = moment(e.rowData.scheduletime, 'hh:mm a');
    this.currentTimeStamp = moment(e.rowData.scheduleDate, 'YYYY-MM-DD');
    this.startDatetemp = moment(e.rowData.scheduleDate, 'YYYY-MM-DD');
    this.endDateTemp = moment(e.rowData.enddate, 'YYYY-MM-DD');
    this.date = e.rowData.repeattype;
    this.years = e.rowData.years
    this.alternativeRecurrence = e.rowData.alternativeRecurrence
      this.date =   e.rowData.repeattype
    this.customreportmstrid =  e.rowData.customreportmstrid
    this.scheduleFor =  e.rowData.scheduleFor
    let month =  e.rowData.months
    if(this.date =='yearly'){
       this.months = month
    }else{
     this.monthType = month
    }

    this.scheduledOn = JSON.parse('["' + e.rowData.scheduledOn.split(',').join('","') + '"]');
    this.monthsDropDown = JSON.parse('["' + e.rowData.scheduledOn.split(',').join('","') + '"]');
    this.years = JSON.parse('["' + e.rowData.scheduledOn.split(',').join('","') + '"]');


    if (this.date == 'daily' || this.date ==='minutes' || this.date ==='hourly') {
      this.options = null;
      this.FormValid.get('scheduledOn').disable();
    } else if (this.date == 'weekly') {

      this.options = this.dayofWeek;

    } else {

      this.options = this.dayOfMonth;

    }
    console.log(`Time: ${moment(this.timestamptemp).format('hh:mm A')} starttime: ${this.startDatetemp} endtime: ${this.endDateTemp} repeat: ${this.scheduledOn} datetype: ${this.date}`);

  }

  onInputChange() {
    // this.endDateTemp = this.startDatetemp
    this.timescheduleDescription();

    console.log(this.timestamptemp);

  }

  async deleteIcon(e) {
    if (confirm("Are you sure you want to delete the record ?")) {
      this.spinner.start();
      console.log(e.rowData.scheduleid);
      console.log('deleteIcon');
      await this.secheduleService.deleteDispatchHistory(e.rowData.scheduleid);

      this.scheduleData();
      this.clearData();
      this.spinner.stop();
    }
  }

  refresh() {
    this.onGridReady(this.gridAPI)

  }








  /* @added by Ravi G
     @date 06-03 2023
     @desc if sceduleFor equals to "Report Template" send schedule data on close of schedule dialog
  */

  rowDoubleClicked($event: any) {
    console.log($event);

    if ($event.data.scheduleFor == "Report Template") {

      this.dialogref.close($event.data);
    }

    /**
   * @author Rahul Vk
   * @Date 14-11-2025
   * @Desc if sceduleFor equals to "pss_doc_Schedule" send schedule data on close of schedule dialog
   */
    if ($event.data.scheduleFor == "pss_doc_Schedule") {

      this.dialogref.close($event.data);
    }

  /**
   * @author Rahul Vk
   * @Date 05-02-2026
   * @Desc if sceduleFor equals to "jsip_meeting_schedule" send schedule data on close of schedule dialog
   */
    if ($event.data.scheduleFor == "jsip_meeting_schedule") {

      this.dialogref.close($event.data);
    }

  

  }


  onEndDateChange() {
    this.timescheduleDescription()
  }
  /*@Added BY Ravi G
    @Desc
  * */
  minDate: any;
  maxDate: any;

  updateFormControlsAvailability() {
    // Determine if form controls should be disabled based on date selection
    const shouldDisable = this.date !== 'yearly';
    // If date is not monthly, enable the month dropdown and set its default value to the current month

    // Loop through each form control to disable/enable them
    this.formControlsToDisable.forEach(controlName => {
      // Get reference to form control
      const control = this.FormValid.get(controlName);

      // Enable/disable form control based on date selection
      shouldDisable ? control.disable() : control.enable();

      // If form control is disabled, reset it
      if (shouldDisable) {
        // Log message to console for debugging purposes
        console.log(`Resetting ${controlName}`);

          control.reset();
      }
    });

    if (this.date === 'monthly' ) {

      console.log('Enabling monthType dropdown and setting default value');
      this.FormValid.get('monthType').enable();
      this.monthType = this.currentMonth;
      /**
       * modify By : Nitin K
       * getting date dynamicly earlier it was hard coded as date 1
       */
      const currentDate = new Date().getUTCDate();
      console.log(currentDate)
      this.scheduledOn = [currentDate];
      console.log(this.scheduledOn)
     // this.scheduledOn = [1]
    }else {

      this.FormValid.get('monthType').disable();
      this.FormValid.get('monthType').reset();
      this.monthType = 0;

    }
    if(this.date != 'weekly'){
      this.FormValid.get('alternativeRecurrence').enable() ;
      if(this.date =='minutes'){
        this.alternativeRecurrence =5;
      }else{
        this.alternativeRecurrence =1
      }
    }else{
      this.FormValid.get('alternativeRecurrence').enable();
      /**
       * Modified By : Nitin Kumar
       * modify the code to take the current day of week dynamicly earlier is was hardcoded to Monday
       */
      const currentDay = new Date().getUTCDay();
     this.scheduledOn = [this.dayofWeek[currentDay-1].id]
    
    }
   
    if(this.date != 'daily' && this.date !='hourly' && this.date != 'minutes'){
      this.FormValid.get('scheduledOn').enable();
      this.FormValid.get('scheduledOn').reset();
    }
    else{
      this.FormValid.get('scheduledOn').disable();
      // this.FormValid.get('scheduledOn').reset();

    }
    if (this.date == 'yearly'){
      this.scheduledOn = [1]
    }
  }

  onHeader2Click() {
    if (this.data.scheduleFor === 'Dataset Refresh') {
      this.showOnlyButtons = true;
    }
    
}
  onHeader1Click() {
    if (this.data.scheduleFor === 'Dataset Refresh') {
      this.showOnlyButtons = false;
    }
}
  onProceed() { 
  
    if (this.data.edata.rowData.status === "No") {
      this.snackbar.open("Cannot refersh deleted Dataset", "OK", { duration: 5000 });
      return;
    }
    /**
   * modified by Chandra R
   * 01/06/2024
   * added Validation for dataset refresh if any dataset generation is "In Progress" then it cannot be refreshed
   */
    if (this.data.edata.rowData.generationStatus == "In Progress") {
      this.snackbar.open("Dataset Generation is in Progress try Later", "OK", { duration: 5000 });
      return;
    }

    if (confirm("Are you sure you want to refresh dataset?")) {
      this.spinner.start();
      this.service.refreshDataset(this.data.edata.rowData.reportcreationid).subscribe(result => {
        if (result.error) {
          this.snackbar.open(result.statusMessage + result.data, "OK", { duration: 5000 });
        } else {
          this.snackbar.open(result.statusMessage, "OK", { duration: 5000 });
        }
        //this.refreshRun();
        this.spinner.stop();
        this.dialogref.close();
        this.showOnlyButtons = false;
      });
      }
    

}
}



